module.exports = __webpack_public_path__ + "static/media/empty-state.5f26b284.png";